
'use server';

import type { GenerateTechIdeaOutput } from '@/backend-types';

const API_BASE_URL = process.env.NEXT_PUBLIC_BACKEND_API_URL;

// This type definition is a placeholder. A more robust solution would be to
// share types between the frontend and backend.
export type { GenerateTechIdeaOutput };
export interface GenerateTechIdeaInput {
  keywords: string;
}


export async function getTechIdea(input: GenerateTechIdeaInput): Promise<{
  success: boolean;
  data?: GenerateTechIdeaOutput;
  message?: string;
}> {
  console.log(`[Action] Calling backend to generate tech idea at: ${API_BASE_URL}/api/generate/tech-idea`);
  try {
    const token = 'YOUR_JWT_TOKEN_HERE'; // In a real app, you'd get this from the user's session
    const response = await fetch(`${API_BASE_URL}/api/generate/tech-idea`, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${token}` // This will be needed when auth is fully implemented
        },
        body: JSON.stringify(input),
    });

    const result = await response.json();

    if (!response.ok) {
        throw new Error(result.message || 'Failed to generate idea.');
    }
    
    console.log('[Action] Successfully received tech idea from backend.');
    return { success: true, data: result.data };
  } catch (error) {
    console.error('Error generating tech idea:', error);
    const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred.';
    return { success: false, message: `Failed to generate idea: ${errorMessage}` };
  }
}
